import PropTypes from "prop-types";
import { useState } from "react";
import SFTextField from "../textField";
import getStyled from "../../hooks/getStyled";
import { SFSearchIcon, SFCloseIcon } from "../icons";
import SFIconButton from "../button/iconButton";
import InputAdornment from "@mui/material/InputAdornment";

const { styled } = getStyled();

const SFTextFieldStyled = styled(SFTextField)(({ theme }) => ({
  "& .MuiFilledInput-root": {
    "&:hover": {
      backgroundColor: theme.palette.grey100.main,
    },
    "&:before, &:after": {
      opacity: 0,
    },
  },
}));

const SFBasicSearch = ({
  onChange,
  placeholder,
  className,
  variant = "filled",
  size = "medium",
}) => {
  const [value, setValue] = useState("");

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleKeyUp = (e) => {
    if (e.keyCode == 13) {
      onChange(value);
    }
  };

  return (
    <SFTextFieldStyled
      variant={variant}
      placeholder={placeholder}
      value={value}
      onKeyUp={handleKeyUp}
      onChange={handleChange}
      className={className}
      size={size}
      hiddenLabel
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SFSearchIcon color="grey500" />
          </InputAdornment>
        ),
        ...(value.length > 0 && {
          endAdornment: (
            <InputAdornment position="end">
              <SFIconButton onClick={() => setValue("")}>
                <SFCloseIcon size="small" />
              </SFIconButton>
            </InputAdornment>
          ),
        }),
      }}
    />
  );
};

SFBasicSearch.propTypes = {
  // Called when there is a useful change in the search value
  onChange: PropTypes.func,
  // Placeholder when search value is empty
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  // Needed in order to use the getStyled hook
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  //variant used for search input
  variant: PropTypes.oneOf(["filled", "outlined"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
};

export default SFBasicSearch;
